import React from "react"
import { useTranslation } from "react-i18next"

import { RoomOverlay } from "widgets/room/room-overlay/RoomOverlay"

import { useCopyRoomOverlayModel } from "./hooks/useCopyRoomOverlayModel"

export interface CopyRoomOverlayProps {
  payload: CopyRoomOverlayPayload
}

export interface CopyRoomOverlayPayload {
  projectID: string
  roomID: string
}

export const CopyRoomOverlay = React.memo((props: CopyRoomOverlayProps) => {
  const { t } = useTranslation()
  return (
    <RoomOverlay
      id="copy-room-overlay"
      headline={t("Room.Actions.Copy")}
      prefix="room__copy"
      {...useCopyRoomOverlayModel(props)}
    />
  )
})

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    COPY_ROOM_OVERLAY: CopyRoomOverlayPayload
  }
}
